import request from '@/plugins/axios'

export function getUploadSign() {
  // 获取twitter帐号列表
  return request({
    url: '/material/signature',
    method: 'get'
  })
}
